<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow" v-loading="saveloading">     
      <div class="shipping-buttonlists shipping-buttonbottom">
          <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
          <el-button type="warning" size="mini" icon="el-icon-download" round @click="downshippingmodel">导出未添加快递的订单</el-button>
          <el-button type="success" size="mini" icon="el-icon-upload2" round @click="uploadshippingfile">上传文件</el-button>
          <el-button type="primary" size="mini" round style="float:right" @click="saveordershipping">确 定</el-button>
          <el-button type="" size="mini" round style="float:right" @click="closewindow">取 消</el-button>
      </div>

      <div class="shipping-main-content" v-loading="uploadgoodsLoading">
          <div class="input-shipping-orderlists" v-for="(item,index) in ordershippings" :key="index">
             <div class="input-shipping-orders">
                <div class="input-shipping-ordernumber">{{item.ordernumber}}<i>（已录快递：{{item.shippings.length}}个）</i></div>
                <el-button type="danger" size="mini" circle icon="el-icon-delete" style="margin-left:2%" @click="delorders(index)"></el-button>
             </div>
             <div class="input-shipping-list" v-for="(tt,ii) in item.shippings" :key="ii">
                <div class="input-shipping-lists-name">{{tt.name}}（{{tt.code}}） - {{tt.shippingcode}}</div>
                <el-button type="danger" size="mini" circle icon="el-icon-delete" style="margin-left:2%" @click="delshippings(index,ii)"></el-button>
             </div>
          </div>
      </div>

      <div class="shipping-buttonlists shipping-buttontop">
          <el-button type="warning" size="mini" icon="el-icon-download" round @click="downshippingmodel">导出未添加快递的订单</el-button>
          <el-button type="success" size="mini" icon="el-icon-upload2" round @click="uploadshippingfile">上传文件</el-button>
          <el-button type="primary" size="mini" round style="float:right" @click="saveordershipping">确 定</el-button>
          <el-button type="" size="mini" round style="float:right" @click="closewindow">取 消</el-button>
      </div>
        
  </div>
  </transition> 
</template>

<script>
export default {
  props: ["value"],
  data () {
    return {
      url:this.GLOBAL.domain+"Sellshippingbirld/index",
      transitionshow:true,
      uploadgoodsLoading:false,
      ordershippings:[],
      saveloading:false,
      sortindex:0,
    }  
  },

  watch: {

    value(val) {
      if (val) {
          this.ordershippings=[];
      }
    },

  },

  mounted(){
     this.ordershippings=[];
  },

  methods:{

    //保存已上传的快递信息
    saveordershipping() {
       var data=[];
       this.ordershippings.forEach(function(item,i) {
          item.shippings.forEach(function(tt,ii) {
              data.push({orderid:item.orderid,ordernumber:item.ordernumber,shippingid:tt.id,code:tt.shippingcode});
          });
       });

        this.saveloading=true;
        var resource = this.$resource(this.url);
        resource.save({act:'saveordershippings',token:this.$cookies.get('token'),data:JSON.stringify(data)}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.saveloading=false;
          }else{
             this.saveloading=false;
             this.$emit("finish");
          }
        }).catch((res) => {
           this.saveloading=false;
        });

    },


    //删除订单所有物流信息
    delorders(index) {
      this.$delete(this.ordershippings,index);
    },

    //删除快递信息
    delshippings(index,ii) {
      this.$delete(this.ordershippings[index].shippings,ii);
      if(this.ordershippings[index].shippings.length==0) this.$delete(this.ordershippings,index);
    },


    //下载未添加快递的订单信息
    downshippingmodel() {
      location.href=this.GLOBAL.exportUrl+"Sellshippingbirld/index/act/downmallordermodel/token/"+this.$cookies.get('token');
    },

    //上传文件信息
    uploadshippingfile() {
      document.getElementById("fileupload").click();
    },

    //保存添加的快递信息
    importfile(obj) {
        let _this = this;
        this.ordershippings=[];
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file = event.currentTarget.files[0];                
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var outdata;
        var reader = new FileReader();
        FileReader.prototype.readAsBinaryString = function(f) {
        	var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;
                
                //提交数据到后台
                _this.uploadgoodsLoading=true;
        		    var resource = _this.$resource(_this.url);
                resource.save({act:'inputinfos',infos:outdata,token:_this.$cookies.get('token')}).then((res) => {
                    if(res.data.Result>0){
                    	if(res.data.Result=='70001') this.$router.push('/login')
                    	_this.uploadgoodsLoading=false;
                    	_this.$message({
                        dangerouslyUseHTMLString: true,
                        type:'error',
                        message:'<span style="line-height:20px">'+res.data.Message+'</span>',
                      });
                    }else{
                    	_this.ordershippings=JSON.parse(Base64.decode(res.data.Data));
                    	_this.uploadgoodsLoading=false;
                    	_this.$message.success('导入商品信息成功!');
                  	}
                }).catch((res) => {
                	  _this.uploadgoodsLoading=false;
                    _this.$message.error(this.GLOBAL.errortext);
                });        
                           
            }
            reader.readAsArrayBuffer(f);
        }
               
        if(rABS) {
        	reader.readAsArrayBuffer(f);
        } else {
            reader.readAsBinaryString(f);
        }                 
    },

    //取消当前窗口
    closewindow() {
      this.$emit("finish");
    },


            

  }

}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.shipping-buttonlists {display:inline-block;width:100%;}
.shipping-buttonbottom {border-bottom:1px dashed #dddddd;padding-bottom:20px}
.shipping-buttontop {border-top:1px dashed #dddddd;padding-top:20px}
.shipping-main-content {padding:30px 0}
.input-shipping-orderlists {display:inline-block;width:100%;font-size:14px;font-weight:500;padding:10px 0}
.input-shipping-orders {display:flex;width:100%;padding:10px 0;border-bottom:1px solid #dddddd;align-items:center;margin-bottom:10px}
.input-shipping-ordernumber {display:inline-block;}
.input-shipping-ordernumber i {font-style:normal;font-size:13px;font-weight:500}
.input-shipping-list {display:flex;width:100%;margin:15px 0;font-size:13px;font-weight:500;align-items:center}
.input-shipping-lists-name {display:inline-block;width:65%}
.input-shipping-lists-code {display:inline-block;}
</style>


// WEBPACK FOOTER //
// src/components/mall/shipping/input.vue